export function initProgressRing() {
  document.querySelectorAll('[data-progress-ring]').forEach(el => {
    const value = parseFloat(el.dataset.progressRing) || 0;
    const circle = el.querySelector('circle[data-ring-fill]');
    if (!circle) return;

    const r = parseFloat(circle.getAttribute('r')) || 40;
    const circumference = 2 * Math.PI * r;
    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference - (value / 100) * circumference;
  });
}
